import React, { useState } from 'react';
import { useLanguage } from '@/i18n/LanguageContext';
import { ImportCourseDialog } from './ImportCourseDialog';
import { Link } from 'react-router-dom';

export const CoursesHeader: React.FC = () => {
  const { t } = useLanguage();
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);

  const handleImportSuccess = () => {
    // Refresh the courses list or show success message
    window.location.reload();
  };

  return (
    <div className="md:flex md:items-center md:justify-between mb-8">
      <div className="flex-1 min-w-0">
        <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
          {t('course-content.title')}
        </h2>
      </div>
      <div className="mt-4 flex md:mt-0 md:ml-4">
        <button 
          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-3"
          onClick={() => setIsImportDialogOpen(true)}
          aria-label={t('course-content.importAriaLabel')}
        >
          {t('course-content.importCourse')}
        </button>
        <Link
          to="/lcms/course-content/new"
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          aria-label={t('course-content.createCourseAriaLabel')}
        >
          {t('course-content.createCourse')}
        </Link>
      </div>

      <ImportCourseDialog
        isOpen={isImportDialogOpen}
        onClose={() => setIsImportDialogOpen(false)}
        onImportSuccess={handleImportSuccess}
      />
    </div>
  );
}; 